export default __webpack_public_path__ + "static/media/sandwich.a20ed583.png";